import { render, staticRenderFns } from "./UserInsurancePolicies.vue?vue&type=template&id=6e754f16&scoped=true&"
import script from "./UserInsurancePolicies.vue?vue&type=script&lang=js&"
export * from "./UserInsurancePolicies.vue?vue&type=script&lang=js&"
import style0 from "./UserInsurancePolicies.vue?vue&type=style&index=0&id=6e754f16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e754f16",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e754f16')) {
      api.createRecord('6e754f16', component.options)
    } else {
      api.reload('6e754f16', component.options)
    }
    module.hot.accept("./UserInsurancePolicies.vue?vue&type=template&id=6e754f16&scoped=true&", function () {
      api.rerender('6e754f16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserInsurancePolicies.vue"
export default component.exports